import React from 'react'

function SingleComment({ CommentorName, date, time, CommentMessage }) {
    return (
        <div className="media-grid">
            <div className="media">
                <a className="comment-img" href={document.location}><img src="https://img.icons8.com/plasticine/50/000000/user-male-circle.png" className="img-responsive" width="100px" alt="placeholder" /></a>
                <div className="media-body comments-grid-right">
                    <h5>{CommentorName}</h5>
                    <ul className="p-0 comment">
                        <li className>{date} at {String(time).substr(0, time.length - 7)}</li>
                        {/* <li>
                            <a href="#comment" className="text-primary">Reply</a>
                        </li> */}
                    </ul>
                    <p>{CommentMessage}</p>
                </div>
            </div>
        </div>
    )
}

export default SingleComment
